<template>
  <div class="noAuth">
    <div class="project-detail">
      <div class="iframe-nav nav-bar">
          <van-nav-bar title="" right-text="" fixed left-arrow @click-left="onClickLeft" />
      </div>
      <div class="content">
        <div class="content-header">
          <div class="header-hd">
            <div class="img">
              <img :src="activityDetail.cover || defaultCover" alt="活动封面">
            </div>
            <div class="header-hd-wrap">
              <span>报名时间：{{ formatDate(activityDetail.startTime) }}至{{ formatDate(activityDetail.endTime) }}</span>
            </div>
          </div>
          <div class="header-bd">
            <h1>{{ activityDetail.raceName }}</h1>
            <div class="info">{{ activityDetail.subtitle }}</div>
            <div class="info info-wrap">
              <span v-if="activityDetail.entrySort !== '0'">参与人数：{{ activityDetail.ybmNum || 0 }}人</span>
<!--              <span>名额限制：{{ activityDetail.numberCeiling || '无限制' }}人</span>-->
            </div>
          </div>
        </div>
        <div class="content-body">
          <van-tabs v-model="activeTab" :color="activeColor" :title-active-color="activeColor" @click="onClick">
            <van-tab title="大赛简介">
              <div class="web-view" v-html="activityDetail.entryExplain || '暂无活动详情'"></div>
            </van-tab>
<!--            <van-tab title="报名说明">
              <div class="web-view" v-html="activityDetail.entryExplain"></div>
            </van-tab>-->
          </van-tabs>
        </div>
      </div>
      <div>
        <div class="footer">
          <van-button block type="info" size="large" :loading="loading" :disabled="!canJoin || !isInSignupTime(activityDetail) || activityDetail.status === '1' "
            @click="handleEnterProject">
            {{ buttonText }}
          </van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import NavBar from 'vant/lib/nav-bar';
import 'vant/lib/nav-bar/style';
import Tabs from 'vant/lib/tabs';
import 'vant/lib/tabs/style';
import Tab from 'vant/lib/tab';
import 'vant/lib/tab/style';
import Button from 'vant/lib/button';
import 'vant/lib/button/style';
import Toast from 'vant/lib/toast';
import 'vant/lib/toast/style';

Vue.use(NavBar)
Vue.use(Tabs)
Vue.use(Tab)
Vue.use(Button)
Vue.use(Toast)

import { fetchDetail } from '@/api/activity/index'

// 默认封面图
const defaultCover = 'https://zhongbei2025.oss-cn-beijing.aliyuncs.com/zbst/zbst/2025/08/19/d9a66f4c-e2cc-4935-9a29-304151203aa1.jpg'

export default {
  data() {
    return {
      activityId: null,
      activityDetail: {
        cover: '',
        raceName: '',
        subtitle: '',
        startTime: '',
        endTime: '',
        entryExplain: '',
        ybmNum: 0,
        numberCeiling: 0,
        status: "0",
        joinStatus: null
      },
      activeTab: 0,
      activeColor: "rgb(59, 112, 255)",
      loading: false,
      defaultCover: defaultCover
    }
  },
  computed: {
    canJoin() {
      // 根据实际业务逻辑判断是否可以参加
      return this.activityDetail.joinStatus === "3" // 假设"0"表示活动进行中
    },
    buttonText() {
      if (this.loading) return '加载中...'
      // if (this.activityDetail.joinStatus !== "0") {
      //   return '活动已结束'
      // }
      if (this.activityDetail.status === '1') {
        return '已结束'
      }

      const now = new Date().getTime()
      const startTime = new Date(this.activityDetail.startTime).getTime()
      const endTime = new Date(this.activityDetail.endTime).getTime()

      if (now < startTime) {
        return '未开始'
      } else if (now > endTime) {
        return '已结束'
      } else {
        if (this.activityDetail.joinStatus !== "3") {
          return '已报名'
        }
        return '立即报名'
      }
    }
  },
  created() {
    this.activityId = this.$route.query.id || this.$route.params.id
    if (this.activityId) {
      this.getActivityDetail()
    } else {
      Toast.fail('活动ID不存在')
      this.$router.go(-1)
    }
  },
  // 首次进入执行（无缓存时）
  mounted() {
    // 延迟 0ms 触发，确保在路由完成后执行
    this.$nextTick(() => {
      document.title = '网络学院';
    });
  },
  // 从缓存激活时执行（返回再进入必触发）
  activated() {
    this.$nextTick(() => {
      document.title = '网络学院';
    });
  },
  methods: {
    async getActivityDetail() {
      this.loading = true
      try {
        const response = await fetchDetail({ id: this.activityId })
        if (response.code === 200 && response.data) {
          this.activityDetail = {
            ...this.activityDetail,
            ...response.data
          }
          // document.title = this.activityDetail.raceName || '活动详情'
        } else {
          Toast.fail(response.msg || '获取活动详情失败')
        }
      } catch (error) {
        console.error('获取活动详情失败:', error)
        Toast.fail('网络错误，请重试')
      } finally {
        this.loading = false
      }
    },

    formatDate(dateTime) {
      if (!dateTime) return '--'
      // 处理带有时分秒的日期
      return dateTime.split(' ')[0]
    },

    handleEnterProject() {
      // 检查是否在报名时间内
      const now = new Date().getTime()
      const startTime = new Date(this.activityDetail.startTime).getTime()
      const endTime = new Date(this.activityDetail.endTime).getTime()

      if (now < startTime) {
        this.$message.warning('活动还未开始报名')
        return
      }

      if (now > endTime) {
        this.$message.warning('活动已结束报名')
        return
      }

      if (!this.canJoin) {
        Toast.fail('您已经参加了，无法报名')
        return
      }

      if (this.activityDetail.ybmNum >= this.activityDetail.numberCeiling) {
        Toast.fail('报名人数已满，无法报名')
        return
      }

      this.$router.push({
        name: 'signup-form',
        query: {
          id: this.activityId,
          raceName: this.activityDetail.raceName
        }
      })
    },

    onClick(name, title) {
      console.log('点击tab:', name, title)
    },

    onClickLeft() {
      this.$router.go(-1)
    },

    // 检查是否在报名时间内
    isInSignupTime(item) {
      if (item.status === '1') return false

      const now = new Date().getTime()
      const startTime = new Date(item.startTime).getTime()
      const endTime = new Date(item.endTime).getTime()

      return now >= startTime && now <= endTime
    },
  }
}
</script>

<style lang="scss" scoped>
/* 保持原有的样式不变 */
.noAuth {
  width: 100%;
  height: 100%;

  .project-detail {
    height: 100%;

    .nav-bar {
      position: relative;
    }

    .iframe-nav {
      ::v-deep .van-nav-bar {
        background-color: transparent;
        position: absolute;
        z-index: 100;
        height: 47px;
      }

      ::v-deep .fixed {
        position: fixed;
        width: 100%;
        margin: 0 auto;
        left: 0;
        right: 0;
      }

      ::v-deep i.van-nav-bar__arrow {
        color: #fff;
        z-index: 10000;
      }

      ::v-deep .van-icon {
        font-size: 18px;
      }
    }

    .content {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      height: 100%;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;

      .content-header {
        .header-hd {
          position: relative;
          height: 250px;
          width: 100%;

          @media (min-width: 768px) {
            height: 400px;
            /* PC端更高的图片区域 */
            max-height: 60vh;
            /* 限制最大高度 */
          }

          .img {
            height: 100%;
            width: 100%;
            pointer-events: none;
            background-color: #f5f5f5;

            img {
              height: 100%;
              width: 100%;
              object-fit: cover;
              object-position: center;
              /* 居中显示 */
              pointer-events: none;
            }
          }

          .header-hd-wrap {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-orient: horizontal;
            -webkit-box-direction: normal;
            -ms-flex-direction: row;
            flex-direction: row;
            -webkit-box-pack: justify;
            -ms-flex-pack: justify;
            justify-content: space-between;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 3;
            height: 20px;
            padding: 8px;
            background: url('../../assets/img/sign/project-header-bg.png') no-repeat;
            background-size: cover;

            span {
              display: inline-block;
              font-size: 14px;
              font-weight: 400;
              color: #fff;
              line-height: 20px;
              background: -webkit-gradient(linear, left top, right top, from(#eba300), color-stop(10%, rgba(247, 141, 6, .73)), color-stop(30%, rgba(255, 192, 0, 0)));
              background: linear-gradient(90deg, #eba300 0, rgba(247, 141, 6, .73) 10%, rgba(255, 192, 0, 0) 30%);
              padding: 0 0 0 5px;
              border-radius: 5px;
            }
          }
        }

        .header-bd {
          padding: 20px 16px;
          border-bottom: 8px solid #f5f5f5;

          h1 {
            font-size: 21px;
            font-weight: 600;
            color: #333;
            line-height: 29px;
            margin: 0 0 15px;
            word-break: break-all;
          }

          .info {
            font-size: 13px;
            font-weight: 400;
            color: #999;
            line-height: 18px;
            margin: 0 0 4px;
            word-break: break-all;
          }

          .info-wrap {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-orient: horizontal;
            -webkit-box-direction: normal;
            -ms-flex-direction: row;
            flex-direction: row;
            -webkit-box-pack: justify;
            -ms-flex-pack: justify;
            justify-content: space-between;
          }
        }
      }

      .content-body {
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        padding: 8px 0 0;
        overflow-y: auto;

        ::v-deep .van-tab {
          font-size: 16px;
        }

        ::v-deep .van-tab--active {
          color: #323233;
          font-weight: 500;
        }

        ::v-deep .van-tabs__wrap {
          border-bottom: 1px solid #eee;
        }

        .web-view {
          margin-top: 10px;
          line-height: 1.6;
          overflow: hidden;
          word-break: break-all;
          padding: 20px 20px 72px;
          font-size: 15px;
          color: #333;

          ::v-deep img {
            max-width: 100%;
            height: auto;
          }

          ::v-deep p {
            margin: 10px 0;
          }
        }
      }
    }
  }

  .footer {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    align-items: center;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    padding: 5px 6px;
    background: #fff;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, .12);

    ::v-deep .van-button {
      display: block;
      width: 100%;

      &--disabled {
        opacity: 0.6;
      }
    }
  }
}
</style>
